
import { gql } from 'apollo-boost';

export const GET_GAIG_PRODUCTS = gql`
  query GetGaigProducts($accountId: ID!) {
    gaigProposalProducts(accountId: $accountId) {
      proposalProductId
      title
      cost
      retailCost
      thirdPartyUrl
      createdDateTime
      modifiedDateTime

      markup {
        markup
        type
      }

      aftermarketProduct {
        aftermarketProductId
        aftermarketVendorApiChannel
        productIsNoLongerAvailable
        criteria
        externalId
        productCategory
        productDescriptionExternal
        productDescriptionInternal
        productName
        productType
        createdDateTime
        modifiedDateTime
        productLogoUrl
        sourceOfCreation

        config {
          criteriaValues
        }

        aftermarketProductCatalogDetails {
          productSummary
          limitationsOfLiability
          eligibilityAndInclusions
          legalDisclaimer
          paragraphDescription
          coverageDetails
        }

        partnerLinks {
          name
          partnerLinkId
        }

        documents {
          documentId
          docName
          source
        }
      }
    }
  }
`;
